import { render } from "./NewsHKListing.vue?vue&type=template&id=f276b45a&scoped=true"
const script = {}

import "./NewsHKListing.vue?vue&type=style&index=0&id=f276b45a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f276b45a"]])

export default __exports__